import { Fragment, useState } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownListById } from "../../../forms/form-components";
import { useSelector } from "react-redux";
import { dateOnlyString, dateTimeString } from "../../../lib/utils";

//query builder
import { formatQuery, QueryBuilder, ValueEditor } from "react-querybuilder";
import { QueryValueEditor } from "../../../components/querybuilder/queryvalueeditor";
import { getQueryOperators } from "../../../components/querybuilder/queryoperators";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

// import { QueryBuilderDnD } from '@react-querybuilder/dnd';
// import * as ReactDnD from 'react-dnd';
// import * as ReactDndHtml5Backend from 'react-dnd-html5-backend';

//import 'react-querybuilder/dist/query-builder.css';

export const WidgetFilterFormSearch = (props) => {
  const {
    isGlobal,
    formRenderProps,
    pageState,
    formState,
    onFormValueChange,
    onSearchChange,
    onKeyChange,
    ...other
  } = props;
  const { t } = useTranslation();

  const currentTheme = useSelector((state) => state.currentTheme);
  // const dispatch = useDispatch();
  
  const whereObject = formState.whereObject;
  // const whereStatement = formState.whereStatement;
  // const whereParameters = formState.whereParameters;
  const whereFields = formState.whereFields;
  const title = isGlobal
    ? t("reporting.view.globalsearch")
    : t("reporting.view.search");

  const getOperators = (fieldName) => {
    let field = whereFields.find((e) => e.Name == fieldName);
    if (!field) return [];

    return getQueryOperators(field.DataTypeId, field.IsLookup);
  };

  //console.log("widgetfilterformsracg", whereObject)
  return (
    <Fragment>
      <div className="widget-filter-form-search">
        <div
          className="widget-filter-form-group"
          style={{ marginTop: 2, marginBottom: 0 }}
        >
          <div className="header">{title}</div>
          <div className="content" style={{ padding: "12px 12px" }}>
            {!isGlobal && (
              <div
                className="row combine-where"
                style={{
                  marginBottom: 24,
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div>
                  <Checkbox
                    style={{ marginRight: 4 }}
                    label={t("reporting.view.combine1")}
                    value={formState.combineWhere}
                    onChange={(e) =>
                      onFormValueChange({ id: "combineWhere", value: e.value })
                    }
                  />
                </div>
                <div>
                  <DropDownListById
                    data={[
                      { Id: 1, Title: t("reporting.view.and") },
                      { Id: 2, Title: t("reporting.view.or") },
                    ]}
                    dataItemKey="Id"
                    textField="Title"
                    value={formState.combineWhereOperator}
                    style={{ marginTop: 4 }}
                    onChange={(e) =>
                      onFormValueChange({
                        id: "combineWhereOperator",
                        value: e.value,
                      })
                    }
                  />
                </div>
              </div>
            )}
            <QueryBuilder
              fields={whereFields}
              query={whereObject}
              onQueryChange={(q) => {
                onSearchChange(q);
              }}
              getOperators={getOperators}
              controlElements={{
                valueEditor: (editorProps) => (
                  <QueryValueEditor
                    {...editorProps}
                    handleSaveKey={props.onKeyChange}
                  />
                ),
              }}
              showCloneButtons={true}
            />
          </div>
        </div>
      </div>
      <style>
        {`
                    .widget-filter-form-search
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex:1;
                    }

                    /*query builder*/
                    .widget-filter-form-search .queryBuilder .ruleGroup, .widget-filter-form-search .queryBuilder .ruleGroup-combinators,
                    .widget-filter-form-search .queryBuilder .ruleGroup-addRule, .widget-filter-form-search .queryBuilder .ruleGroup-addGroup,
                    .widget-filter-form-search .queryBuilder .rule-remove, .widget-filter-form-search .queryBuilder .ruleGroup-remove,
                    .widget-filter-form-search .queryBuilder .rule-fields, .widget-filter-form-search .queryBuilder .rule-operators,
                    .widget-filter-form-search .queryBuilder .rule-value, .widget-filter-form-search .queryBuilder .rule-cloneRule
                    {
                        border-color: ${currentTheme.componentBorderColor};
                        background-color: ${currentTheme.componentBg};
                        color: ${currentTheme.componentText};                                               
                    }

                    .widget-filter-form-search .queryBuilder .rule-fields:focus, .widget-filter-form-search .queryBuilder .rule-operators:focus,
                    .widget-filter-form-search .queryBuilder .rule-value:focus
                    {
                        outline: none
                    }    
                    
                    .widget-filter-form-search .queryBuilder .rule-remove, .widget-filter-form-search .queryBuilder .ruleGroup-remove
                    {
                        color: ${currentTheme.error};
                        padding: 8px 10px 7px 10px;
                    }

                    @media (max-width: 600px)
                    {
                        .widget-filter-form-search .queryBuilder .ruleGroup,
                        .widget-filter-form-search .queryBuilder .rule
                        {
                            flex-wrap: wrap;
                        }

                        .widget-filter-form-search .queryBuilder select,
                        .widget-filter-form-search .queryBuilder input
                        {
                            max-width: 100%;
                        }
                    }
                    `}
      </style>
    </Fragment>
  );
};
